<template>
  <div ref="layout" class="page-form page-base">
    <h3 class="title">销售计划显示</h3>

    <div class="form-container">
      <el-row>
        <el-button size="mini" @click="backDetail">返回</el-button>
      </el-row>
      <el-form
        ref="form"
        disabled
        inline
        size="mini"
        label-width="150px"
        :model="conditions"
      >
        <common-title title="基本信息" />
        <el-row :gutter="24">
          <el-col :lg="8" :md="12">
            <el-form-item label="销售计划编号">
              <el-input v-model="conditions.plan_number" placeholder="自动生成" disabled />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="提报类型">
              <el-input v-model="conditions.report_type_text" />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="计划类型">
              <el-input v-model="conditions.plan_type_text" />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="客户编号">
              <el-input v-model="conditions.customer" />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="客户名称">
              <el-input
                v-model="conditions.cust_name"
                placeholder="请输入"
                type="text"
                clearable
                disabled
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="客户类型">
              <el-input v-model="conditions.customer_type_text" />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="存货分类">
              <el-input v-model="conditions.wlybrand_text" />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="年度" prop="gjahr">
              <el-input v-model="conditions.gjahr" />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="月份" prop="monat">
              <el-input v-model="conditions.monat" />
            </el-form-item>
          </el-col>
        </el-row>
        <common-title title="计划量" />
        <el-row :gutter="24">
          <el-col :lg="8" :md="12">
            <el-form-item class="line-16" label="总计划量(件)">
              <el-input v-model="conditions.total_qty" />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item class="line-16" label="初始计划量(件)">
              <el-input v-model="conditions.initplan_qty" />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item class="line-16" label="已开票计划量(件)">
              <el-input v-model="conditions.billing_qty" />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item class="line-16" label="已占用计划量(件)">
              <el-input v-model="conditions.atp_qty" />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item class="line-16" label="剩余可用计划量(件)">
              <el-input v-model="conditions.remain_qty" />
            </el-form-item>
          </el-col>
        </el-row>



        <el-row :gutter="24">
          <el-col :lg="8" :md="12">
            <el-form-item class="line-16" label="总计划量(瓶)">
              <el-input v-model="conditions.total_bot" />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item class="line-16" label="初始计划量(瓶)">
              <el-input v-model="conditions.initplan_bot" />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item class="line-16" label="已开票计划量(瓶)">
              <el-input v-model="conditions.billing_bot" />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item class="line-16" label="已占用计划量(瓶)">
              <el-input v-model="conditions.atp_bot" />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item class="line-16" label="剩余可用计划量(瓶)">
              <el-input v-model="conditions.remain_bot" />
            </el-form-item>
          </el-col>
        </el-row>

        <common-title title="计划额(参考)" />
        <el-row :gutter="24">
          <el-col :lg="8" :md="12">
            <el-form-item class="line-16" label="总计划额(万元)">
              <el-input v-model="conditions.total_amt" />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item class="line-16" label="初始计划额(万元)">
              <el-input v-model="conditions.initplan_amt" />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item class="line-16" label="已开票计划额(万元)">
              <el-input v-model="conditions.billing_amt" />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item class="line-16" label="已占用计划额(万元)">
              <el-input v-model="conditions.atp_amt" />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item class="line-16" label="剩余可用计划额(万元)">
              <el-input v-model="conditions.remain_amt" />
            </el-form-item>
          </el-col>
        </el-row>

        <common-title title="区域" />
        <el-row :gutter="24">
          <el-col :lg="8" :md="12">
            <el-form-item label="营销单元" prop="sal_center">
              <el-input v-model="conditions.sal_center_name" />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="基地">
              <el-input v-model="conditions.sal_base_text" />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="省份">
              <el-input v-model="conditions.region_text" />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="城市">
              <el-input v-model="conditions.city_text" />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="业务员">
              <el-input v-model="conditions.sales_emp_name" />
            </el-form-item>
          </el-col>
        </el-row>
        <common-title title="状态" />
        <el-row :gutter="24">
          <el-col :lg="8" :md="12">
            <el-form-item label="创建人">
              <el-input v-model="conditions.uname" />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="创建日期">
              <el-input v-model="conditions.datum" />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="状态">
              <el-input v-model="conditions.porder_status_text" />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>

    <div class="table-container">
      <TableCommon title="更新记录" :custome-config="() => vxeShowCustom('xTable')">
        <vxe-grid
          ref="xTable"
          class="table-block"
          border
          :highlight-hover-row="true"
          resizable
          :show-overflow="true"
          height="240"
          max-height="550"
          align="center"
          size="mini"
          :empty-render="{ name: 'NotData' }"
          :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
          :edit-config="{ trigger: 'manual', mode: 'row' }"
          :columns="gridOptions.columns"
          :data="gridOptions.data"
        >
          <template #plan_order="{row}">
            <span class="blue" @click="toDetail(row)">{{ row.plan_order }}</span>
          </template>
        </vxe-grid>
      </TableCommon>
    </div>
  </div>
</template>
<script>
import { getSalePlanNum } from '@/api/sap/sale-plan'

export default {
  props: ['planNum'],
  data() {
    return {
      selectDataOptions: {},
      conditions: {},
      gridOptions: {
        data: [],
        columns: [
          { field: 'plan_order', title: '单据编号', slots: { default: 'plan_order' }},
          { field: 'order_type_text', title: '单据类型' },
          { field: 'plan_qty', title: '计划量(件)' },
          { field: 'plan_bot', title: '计划量(瓶)' },
          { field: 'plan_amt', title: '计划额' },
          { field: 'datum', title: '创建日期' },
          { field: 'uzeit', title: '创建时间' }
        ]
      }
    }
  },
  computed: {
  },
  created() {
    this.getDetail()
  },

  methods: {
    backDetail() {
      if (this.$route.query.action) {
        this.$router.go(-1)
      } else {
        this.$emit('change-action', 'list')
      }
    },
    async getDetail() {
      const { head, history } = await getSalePlanNum({
        iv_plan_number: this.planNum
      })
      this.conditions = {
        ...head
      }
      this.gridOptions.data = history
    },
    toDetail(row) {
      if (row.order_type === 'ZP01') {
        this.$router.push({
          path: '/wly/sale-plan/sale-plan-check',
          query: {
            order: row.plan_order
          }
        })
      } else {
        this.$router.push({
          path: '/wly/sale-plan/sale-plan-change-check',
          query: {
            order: row.plan_order
          }
        })
      }
    }
  }

}
</script>

<style lang="scss" scoped>
.blue {
  color: rgb(45, 146, 214);
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/views/sale-plan-manage/components/SalePlanDetail.vue